import { InstanceScreen } from 'component/navigation/instance';

export default function LoginCodeRedirectScreen() {
    return <InstanceScreen screenKey='codeRedirect' />;
}
